module.exports = __webpack_public_path__ + "static/media/play_icon.a52c2b09.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Features/TelestrationsVideoLibrary/Assets/Player/Engaged/play_icon.svg
// module id = 7431
// module chunks = 0